import { zodResolver } from "@hookform/resolvers/zod";
import Button from "../../../../../../../../library/button";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { ButtonsWrapper, Field, Form, TextWrapper } from "./styled";
import { useForm } from "react-hook-form";
import { UpdateTranscriptionNotificationSchema, schema } from "./schema";
import Switch from "../../../../../../../../library/switch";
import { Text } from "../../../../../../../../library/text";
import { Title } from "../../../../../../../../library/title";
import useUpdateNotifications from "../../../../../../../../hooks/useUpdateNotifications";

interface Props {
  email?: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
}

const EditModal = ({ email = false, onClose, onSuccess, onError }: Props) => {
  const { updateNotifications } = useUpdateNotifications();
  const {
    watch,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<UpdateTranscriptionNotificationSchema>({
    resolver: zodResolver(schema),
    defaultValues: { email },
  });

  const emailNotification = watch("email");

  const updateSettings = async (
    data: UpdateTranscriptionNotificationSchema
  ) => {
    try {
      const update = await updateNotifications("transcriptionComplete", data);
      if (update?.error === null) {
        onSuccess();
      } else {
        throw update.error;
      }
    } catch (e) {
      onError();
    }
  };

  const changeValue = (value: boolean, type: "email" | "sms") => {
    if (type === "email") {
      setValue("email", value);
    }
  };

  return (
    <Form onSubmit={handleSubmit(updateSettings)}>
      <Field>
        <TextWrapper>
          <Title size="xxs">E-post ved ferdig transkribering</Title>

          <Text size="small" color="dark">
            Motta en e-post når filen er ferdig transkribert
          </Text>
        </TextWrapper>
        <Switch
          checked={emailNotification}
          onChange={(val) => changeValue(val, "email")}
          size="small"
        />
      </Field>
      <ButtonsWrapper>
        <Button
          onClick={onClose}
          color="grey"
          variant="regular"
          spacing="right"
        >
          Avbryt
        </Button>
        <Button
          disabled={isSubmitting}
          type="submit"
          color="blue"
          variant="regular"
        >
          {isSubmitting ? (
            <>{getIcon("spinner")} Oppdaterer..</>
          ) : (
            <>Oppdater innstillinger</>
          )}
        </Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default EditModal;
